<template>
  <v-card flat class="product-view">
    <div class="text-center" v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card-text class="pt-0 pb-1">
      <v-row>
        <v-col cols="6" class="pb-0 pt-0">{{ orderModel.number }}</v-col>
        <v-col cols="6" class="pb-0 pt-0 text-right">{{ $t('message.order.ordered') }}: {{ orderModel.orderdate | dateFormat }}</v-col>
        <v-col cols="7" class="pb-0 pt-0">{{ orderModel.salesreference && orderModel.salesreference.trim() !== '' ? orderModel.salesreference : '' }}</v-col>
        <v-col cols="5" class="pb-0 pt-0 pr-0 text-right"><v-btn small color="primary" @click="pickOrderHandler" :disabled="orderModel.status === 'received'">{{ $t('message.order.receive') }}</v-btn></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0 pl-3">{{ orderModel.customer_name || '' }}</v-col>
      </v-row>
    </v-card-text>
    <v-card-text class="highlight pt-0 pb-0 pl-1">
      <v-row>
        <v-col cols="8" class="pa-0 pl-2 font-weight-bold">{{ $t('message.order.products') }}:</v-col>
        <v-col cols="2" class="pa-0 pl-2 text-right font-weight-bold">{{ $t('message.order.ordered') }}</v-col>
        <v-col cols="2" class="pa-0 pl-2 text-right font-weight-bold">{{ $t('message.order.received') }}</v-col>
        <!-- <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.ccsheet.unit') }}</v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <v-row v-for="(product, index) in listOfProducts" :key="index">
        <v-col cols="8" class="pa-0 pl-2" :class="{ 'pb-1': (index === listOfProducts.length - 1)}">
          <v-row>
            <v-col cols="12" class="pa-0 pl-1 text-truncate">{{ product.productnumber }}</v-col>
            <!-- <v-col cols="6" class="pa-0 text-truncate" :title="product.productname">{{ product.productname }}</v-col> -->
          </v-row>
        </v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right">{{ product.orderedqty }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right">
          {{ product.receivedqty }}
        </v-col>
        <!-- <v-col cols="2" class="pa-0 pl-3 text-right">
          <span class="caption">{{ product.unitname }}</span>
        </v-col> -->
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="pickOrderHandler" :disabled="orderModel.status === 'received'">{{ $t('message.order.receive') }}</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      orderId: 0,
      listOfProducts: [],
      orderModel: {}
    }
  },
  mounted () {
    this.loading = true
    this.orderId = this.$route.params.order_id
    this.getOrderProducts()
    this.getOrderInfo()
  },
  methods: {
    getOrderInfo () {
      let model = {
        'expand': [{
          'select': ['name'],
          'model': 'Customer',
          'on_field': 'id',
          'on_parent_field': 'supplierid'
        }],
        'filter': `id eq '${this.orderId}'`
      }
      this.$api.execute('post', 'warehouseorders/query', model)
        .then((response) => {
          if (response.data) {
            this.orderModel = response.data[0]
          }
        })
    },
    getOrderProducts () {
      this.$api.execute('get', `warehouseorders/get_products_by_order/${this.orderId}`)
        .then((response) => {
          if (response.data) {
            let list = response.data
            list.map((x) => {
              x.receivedqty = this.$format.absoluteNumber(x.receivedqty)
              x.orderedqty = this.$format.absoluteNumber(x.orderedqty)
              return x
            })
            this.listOfProducts = list
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    pickOrderHandler () {
      this.$router.push(`/supplier_orders/${this.orderId}/pick`)
    }
  }
}
</script>
